import React, { useEffect, useState } from "react";
import { Button, Card, Checkbox, Col, Form, Input, message, Modal, Row, Select, Tooltip, Upload } from "antd";
import { CloudServerOutlined, DeleteOutlined, HomeOutlined, MailOutlined, PhoneOutlined, UploadOutlined, UserOutlined } from "@ant-design/icons";
import { IPageProps } from "../../../interfaces/page-data";
import HTTPService from "../../../utils/makerequest";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { UserRole } from "../../../interfaces/authentication";

interface PasswordResponse {
  [email: string]: string;
}

const AddCustomer: React.FunctionComponent<IPageProps> = () => {
  const { Option } = Select;
  const { t } = useTranslation();

  const [platformData, setPlatformData] = useState<any>();
  const [isChecked, setIsChecked] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [logoFiles, setLogoFiles] = useState<any[]>([]);

  useEffect(() => {
    GetPlatform();
  }, []);

  const cities = [
    'Adana', 'Adıyaman', 'Afyonkarahisar', 'Ağrı', 'Amasya', 'Ankara', 'Antalya',
    'Artvin', 'Aydın', 'Balıkesir', 'Bilecik', 'Bingöl', 'Bitlis', 'Bolu',
    'Burdur', 'Bursa', 'Çanakkale', 'Çankırı', 'Çorum', 'Denizli', 'Diyarbakır',
    'Edirne', 'Elazığ', 'Erzincan', 'Erzurum', 'Eskişehir', 'Gaziantep', 'Giresun',
    'Gümüşhane', 'Hakkâri', 'Hatay', 'Isparta', 'Mersin', 'İstanbul', 'İzmir',
    'Kars', 'Kastamonu', 'Kayseri', 'Kırklareli', 'Kırşehir', 'Kocaeli', 'Konya',
    'Kütahya', 'Malatya', 'Manisa', 'Kahramanmaraş', 'Mardin', 'Muğla', 'Muş',
    'Nevşehir', 'Niğde', 'Ordu', 'Rize', 'Sakarya', 'Samsun', 'Siirt', 'Sinop',
    'Sivas', 'Tekirdağ', 'Tokat', 'Trabzon', 'Tunceli', 'Şanlıurfa', 'Uşak',
    'Van', 'Yozgat', 'Zonguldak', 'Aksaray', 'Bayburt', 'Karaman', 'Kırıkkale',
    'Batman', 'Şırnak', 'Bartın', 'Ardahan', 'Iğdır', 'Yalova', 'Karabük',
    'Kilis', 'Osmaniye', 'Düzce'
  ];

  const CompanyRegister = (values) => {

    let imagePath: string = "";
    if (logoFiles.length > 0) {
      imagePath = logoFiles[0].filePath;
    }

    const newGroup = {
      companyName: values.companyName,
      companyAddress: values.companyAddress,
      companyCity: values.companyCity,
      isLocal: values.isLocal,
      baseUrl: values.baseUrl,
      companyImagePath: imagePath,
      responsibleUserTBLs: [
        {
          userEmail: values.responsibleEmail,
          firstName: values.responsibleUserFirstname,
          lastName: values.responsibleUserLastname,
          telephone: values.responsibleTelephone,
          role: UserRole.Admin
        },
        {
          userEmail: values.assetManagerEmail,
          firstName: values.assetManagerName,
          lastName: values.assetManagerSurname,
          telephone: values.assetManegerTelephone,
          role: UserRole.AssetManager
        }
      ]
    };


    HTTPService.POST(`/Company/registerCompany`, newGroup)
      .then((response) => {
        if (response.status === 200) {
          if (response.data) {
            const passwords: PasswordResponse = response.data;

            const message = Object.entries(passwords)
              .map(([email, password]) => (
                `${t('user')}: ${email}\n${t('password')}: ${password}`
              ))
              .join('\n\n');

            setPopupMessage(message);
            setShowPopup(true);
          } else {
            setPopupMessage(response.data);
            setShowPopup(true);
          }
        } else if (response.status === 204) {
          toast.success(t('register_success'));
          setTimeout(() => {
            handleRedirect();
          }, 1000);
        } else {
          toast.error(t(response.data));
        }
      })
      .catch((error) => {
        toast.error(t('register_failure'));
      });
  };

  const handleRedirect = () => {
    const currentUrl = window.location.href;
    const redirectUrl = 'admin/add-customer';
    if (currentUrl.includes(redirectUrl)) {
      window.location.replace('admin/customer-management');
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(popupMessage)
      .then(() => {
        message.success(t('password_copy'));
      })
      .catch(err => {
        message.error(t('password_copy_fail'));
      });
  };

  const GetPlatform = () => {
    HTTPService.GET(`/Other/getPlatform`)
      .then((response) => {
        if (response.status === 200) {
          setPlatformData(response.data);
        } else {
          toast.error(t(response.data));
        }
      })
      .catch((error) => {
        toast.error(t('register_failure'));
      });
  };

  const handleCancel = () => {
    window.location.replace('/admin/customer-management/');
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      message.error(t('file_not_image'));
    }
    return isImage;
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 102400) {
        message.error(t('file_too_100'));
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoFiles([
          ...logoFiles,
          { filePath: reader.result }
        ]);
        message.success(t('logo_uploaded_successfully'));
      };
      reader.onerror = () => {
        message.error(t('logo_upload_failed'));
      };
      reader.readAsDataURL(file);
    }
  };


  const handleRemoveLogo = () => {
    setLogoFiles([]);
  };

  return (
    <Card style={{ padding: '50px' }}>
      <h3>{t('register_customer')}</h3>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item>
            <Button
              icon={<UploadOutlined />}
              onClick={() => document.getElementById('file-input').click()}
              style={{ padding: '10px 20px', borderRadius: '5px' }}
              disabled={logoFiles.length > 0}
            >
              {t('choose_logo')}
            </Button>

            <input
              id="file-input"
              type="file"
              accept="image/*"
              onChange={handleLogoChange}
              style={{ display: 'none' }}
            />

            {logoFiles.length > 0 && (
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                <Tooltip title={t('logo_uploaded')}>
                  <img
                    src={logoFiles[logoFiles.length - 1].filePath}
                    alt="logo"
                    style={{ width: '100px', marginRight: '10px' }}
                  />
                </Tooltip>

                <Button
                  icon={<DeleteOutlined />}
                  onClick={handleRemoveLogo}
                  type="text"

                >
                </Button>
              </div>
            )}
          </Form.Item>
        </Col>
      </Row>


      <Form onFinish={CompanyRegister} layout='vertical'>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name='companyName'
              label={t('company_name')}
              rules={[{ required: true, message: t('please_input', { field: t('company_name') }), whitespace: true }]}>
              <Input prefix={<UserOutlined />} style={{ borderRadius: 0 }} placeholder={t('company_name')} />
            </Form.Item>
          </Col>
        </Row>

        {platformData !== 1 && UserRole.AltisAdmin && (
          <Row gutter={8}>
            <Col xs={20} sm={2}>
              <Form.Item style={{ marginTop: '20px', marginLeft: '5px' }} name="isLocal" valuePropName="checked">
                <Tooltip title={t('islocal')}>
                  <Checkbox
                    style={{ transform: 'scale(1.5)' }}
                    onChange={handleCheckboxChange}
                  />
                </Tooltip>
              </Form.Item>
            </Col>
            <Col xs={20} sm={12}>
              <Form.Item
                name="baseUrl"
                rules={[({ getFieldValue }) => ({
                  validator(_, value) {
                    if (getFieldValue('isLocal')) {
                      if (value && value.trim()) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(t('please_input', { field: t('baseUrl') })));
                    }
                    return Promise.resolve();
                  },
                })]}
                style={{ marginTop: '10px', marginLeft: '-60px' }}>
                <Input
                  prefix={<CloudServerOutlined />}
                  style={{ borderRadius: 0, textAlign: 'right', width: 'calc(169% + 60px)', paddingLeft: '8px' }}
                  placeholder={t('baseUrl')}
                  disabled={!isChecked}
                />
              </Form.Item>
            </Col>
          </Row>
        )}

        <Form.Item
          label={t("address")}
          required>
          <Row gutter={16}>
            <Col span={16}>
              <Form.Item
                name="companyAddress"
                rules={[{ required: true, message: t("please_input", { field: t("address") }), whitespace: true }]}>
                <Input
                  prefix={<HomeOutlined />}
                  style={{ borderRadius: 0 }}
                  placeholder={t("address")}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="companyCity"
                rules={[{ required: true, message: t("please_select", { field: t("city") }) }]}>
                <Select
                  showSearch
                  placeholder={t("select_city")}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children?.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                  {cities.map((city) => (
                    <Option key={city} value={city}>
                      {city}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>

        <Form.Item
          label={t('responsible_firstname')}
          name='responsibleUserFirstname'
          rules={[
            { required: true, message: t('please_input', { field: t('responsible_firstname') }), whitespace: true },
            { pattern: /^(?!\s)(?!.*\s$).+$/, message: t('no_leading_or_trailing_spaces') }
          ]}>
          <Input prefix={<UserOutlined />} style={{ borderRadius: 0 }} placeholder={t('responsible_firstname')} />
        </Form.Item>

        <Form.Item
          label={t('responsible_lastname')}
          name='responsibleUserLastname'
          rules={[
            { required: true, message: t('please_input', { field: t('responsible_lastname') }), whitespace: true },
            { pattern: /^(?!\s)(?!.*\s$).+$/, message: t('no_leading_or_trailing_spaces') }
          ]}>
          <Input prefix={<UserOutlined />} style={{ borderRadius: 0 }} placeholder={t('responsible_lastname')} />
        </Form.Item>

        <Form.Item
          name='responsibleTelephone'
          label={t('responsible_telephone')}
          rules={[
            { required: true, message: t('please_input', { field: t('responsible_telephone') }) },
            { pattern: /^[0-9]*$/, message: t('only_numbers') }
          ]}>
          <Input
            prefix={<PhoneOutlined />}
            style={{ borderRadius: 0 }}
            placeholder='+90 512 6897 2541'
          />
        </Form.Item>

        <Form.Item
          name='responsibleEmail'
          label={t('responsible_email')}
          rules={[
            { required: true, message: t('please_input', { field: t('responsible_email') }), whitespace: true },
            { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: t('valid_email') }
          ]}>
          <Input prefix={<MailOutlined />} style={{ borderRadius: 0 }} placeholder='example@gmail.com' />
        </Form.Item>

        <Form.Item
          label={t('asset_manager_name')}
          name='assetManagerName'
          rules={[
            { required: true, message: t('please_input', { field: t('asset_manager_name') }), whitespace: true },
            { pattern: /^(?!\s)(?!.*\s$).+$/, message: t('no_leading_or_trailing_spaces') }
          ]}>
          <Input prefix={<UserOutlined />} style={{ borderRadius: 0 }} placeholder={t('asset_manager_name')} />
        </Form.Item>


        <Form.Item
          label={t('asset_manager_surname')}
          name='assetManagerSurname'
          rules={[
            { required: true, message: t('please_input', { field: t('asset_manager_surname') }), whitespace: true },
            { pattern: /^(?!\s)(?!.*\s$).+$/, message: t('no_leading_or_trailing_spaces') }
          ]}>
          <Input prefix={<UserOutlined />} style={{ borderRadius: 0 }} placeholder={t('asset_manager_surname')} />
        </Form.Item>

        <Form.Item
          name='assetManegerTelephone'
          label={t('asset_manager_telephone')}
          rules={[
            { required: true, message: t('please_input', { field: t('asset_manager_telephone') }) },
            { pattern: /^[0-9]*$/, message: t('only_numbers') }
          ]}>
          <Input
            prefix={<PhoneOutlined />}
            style={{ borderRadius: 0 }}
            placeholder='+90 512 6897 2541'
          />
        </Form.Item>

        <Form.Item
          name='assetManagerEmail'
          label={t('asset_manager_email')}
          rules={[
            { required: true, message: t('please_input', { field: t('asset_manager_email') }), whitespace: true },
            { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: t('valid_email') }
          ]}>
          <Input prefix={<MailOutlined />} style={{ borderRadius: 0 }} placeholder='example@gmail.com' />
        </Form.Item>

        <Form.Item>
          <Row gutter={[8, 8]} justify="end" align="middle">
            <Col xs={12} sm={4}>
              <Button block onClick={handleCancel} type="primary" style={{ borderRadius: '5px' }}>
                {t('cancel')}
              </Button>
            </Col>
            <Col xs={12} sm={4}>
              <Button block htmlType="submit" type="primary" style={{ borderRadius: '5px' }}>
                {t('save')}
              </Button>
            </Col>
          </Row>
        </Form.Item>

        <Modal
          title={t('password_remember')}
          visible={showPopup}
          onCancel={() => {
            setShowPopup(false);
            handleRedirect();
          }}
          footer={[
            <Button key="copy" onClick={handleCopy}>
              {t('copy')}
            </Button>,
            <Button key="ok" type="primary" onClick={() => {
              setShowPopup(false);
              handleRedirect();
            }}>
              {t('ok')}
            </Button>
          ]}>
          <pre style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            fontFamily: 'monospace',
            padding: '10px',
            background: '#f5f5f5',
            borderRadius: '4px'
          }}>
            {popupMessage}
          </pre>
        </Modal>

      </Form>
    </Card>
  );
};

export default AddCustomer;
